import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ComponentField } from '@/types/DynamicForm.type';
import { getQuestionLabel } from '@/utils/dynamicForm.util';
import FormLocationAutocomplete from '@/components/molecules/form/search/FormLocationAutocomplete';

type Props = Extract<ComponentField, { fieldType: 'regionSelect' }>;

/**
 * Dynamic form region select component that provides location selection
 * filtered by the selected country. The component is disabled until a country
 * is selected in the REGION_COUNTRY field.
 * 
 * @param cfg - Field configuration object containing form field properties
 * @returns JSX element for the region select field
 */
const DynamicFormRegionSelect: React.FC<Props> = (cfg) => {
  const { watch } = useFormContext();
  const country = watch("REGION_COUNTRY");

  const countryCode = country ? [country.country_code] : [];

  return (
    <FormLocationAutocomplete
      {...cfg}
      label={getQuestionLabel(cfg)}
      disabled={!country}
      multiple={true}
      showOptionsOnFocus={false}
      helperTextBelowLabel
      config={{
        resultItems: ["CITY", "ZIPCODE", "STATE", "REGION"],
        filter: {
          included_country_codes: countryCode,
        },
      }}
    />
  );
};

export default DynamicFormRegionSelect;